import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import ToastMessage from '@/components/toasts/ToastMessage';
import { toast } from 'react-toastify';
import { useTheme } from '@emotion/react';
import useAppStore from '../../../../store/app';
import Set2FA from '@/components/signup/Set2FA';

export default function ConfirmRegistration() {
  const theme = useTheme();
  const state = useAppStore((state) => state.hero);
  const lg = useMediaQuery(theme.breakpoints.up('lg'));
  const { setDialogForm } = useAppStore();

  const [success, setSuccess] = useState(false);
  const [showSet2FA, setShowSet2FA] = useState(true);

  // Get the session ID from the URL
  const queryParams = new URLSearchParams(window.location.search);
  const secureUID = queryParams.get('secure_UID');
  localStorage.setItem('secureUID', secureUID);

  const handleSuccess = () => {
    setShowSet2FA(false);
    setDialogForm(null);
    setSuccess(true);
    toast.success(
      <ToastMessage title="Passwort und 2FA erfolgreich gesetzt" />,
    );
    localStorage.removeItem('stripeSessionId');
    localStorage.removeItem('secureUID');
  };

  const handleFailure = (message) => {
    setShowSet2FA(false);
    setDialogForm(null);
    setSuccess(false);
    toast.error(<ToastMessage title={message} />);
  };

  return (
    <Box
      id="hero"
      sx={{
        height: 'calc(100vh - 94px)',
        maxWidth: '1500px',
        width: '80%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '92px',
        [theme.breakpoints.down('md')]: {
          mt: '120px',
          flexDirection: 'column-reverse',
          justifyContent: 'flex-start',
          alignItems: 'center',
        },
        [theme.breakpoints.down('sm')]: {
          gap: '32px',
        },
      }}
    >
      {showSet2FA ? (
        <Set2FA onSuccess={handleSuccess} onFailure={handleFailure} />
      ) : success ? (
        <>
          <Box
            sx={{
              width: '500px',
              [theme.breakpoints.down('md')]: {
                pb: '20%',
              },
              [theme.breakpoints.down('sm')]: {
                width: '100%',
                px: '24px',
              },
            }}
          >
            <Typography
              sx={{
                fontWeight: '800',
                fontSize: '48px',
                lineHeight: '1.2',
                [theme.breakpoints.down('sm')]: {
                  fontSize: '28px',
                },
              }}
            >
              Ihr Account wurde erfolgreich registriert!
            </Typography>

            <Typography
              sx={{
                mt: '22px',
                fontSize: '16px',
                [theme.breakpoints.down('sm')]: {
                  fontSize: '14px',
                },
              }}
            >
              Sie können nun fortfahren.
            </Typography>

            <Button
              color="primary"
              sx={{
                mt: '32px',
                width: '180px',
                fontSize: '16px',
                fontWeight: '700',
                border: '3px solid',
                borderRadius: '0',
                '&:hover': {
                  border: '3px solid primary.main',
                },
              }}
              variant="outlined"
              href="/organizer"
            >
              Zum Login
            </Button>
          </Box>
          <Box
            sx={{
              flexShrink: 999,
              [theme.breakpoints.down('sm')]: {
                pt: '50px',
              },
            }}
          >
            {(state === 'graphics' || !lg) && (
              <img
                src="/static/confirmEmail.svg"
                alt="E-Mail bestätigen"
                style={{ maxWidth: '450px', width: '100%' }}
              />
            )}
          </Box>
        </>
      ) : (
        <>
          <>
            <Box
              sx={{
                width: '500px',
                [theme.breakpoints.down('md')]: {
                  pb: '20%',
                },
                [theme.breakpoints.down('sm')]: {
                  width: '100%',
                  px: '24px',
                },
              }}
            >
              <Typography
                sx={{
                  fontWeight: '800',
                  fontSize: '48px',
                  lineHeight: '1.2',
                  [theme.breakpoints.down('sm')]: {
                    fontSize: '28px',
                  },
                }}
              >
                Es ist ein Fehler beim Registrieren ihres Accounts
                aufgetreten.{' '}
              </Typography>

              <Typography
                sx={{
                  mt: '22px',
                  fontSize: '16px',
                  [theme.breakpoints.down('sm')]: {
                    fontSize: '14px',
                  },
                }}
              >
                Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '32px',
                  mt: '32px',
                }}
              >
                <Button
                  color="primary"
                  sx={{
                    width: '180px',
                    fontSize: '16px',
                    fontWeight: '700',
                    border: '3px solid',
                    borderRadius: '0',
                    '&:hover': {
                      border: '3px solid primary.main',
                    },
                  }}
                  variant="outlined"
                  onClick={() => setShowSet2FA(true)}
                >
                  Erneut versuchen
                </Button>
                <Button
                  color="primary"
                  sx={{
                    width: '180px',
                    fontSize: '16px',
                    fontWeight: '700',
                    border: '3px solid',
                    borderRadius: '0',
                    '&:hover': {
                      border: '3px solid primary.main',
                    },
                  }}
                  variant="outlined"
                  href="/"
                >
                  Zur Startseite
                </Button>
              </Box>
            </Box>
            <Box
              sx={{
                flexShrink: 999,
                [theme.breakpoints.down('sm')]: {
                  pt: '50px',
                },
              }}
            >
              {(state === 'graphics' || !lg) && (
                <img
                  src="/static/confirmEmailError.svg"
                  alt="E-Mail bestätigen"
                  style={{ maxWidth: '450px', width: '100%' }}
                />
              )}
            </Box>
          </>
        </>
      )}
    </Box>
  );
}
